import AlternateArtemisFonts from './AlternateArtemisFonts';
import ArtemisFonts from './ArtemisFonts';

const loadArtemisFonts = (text, isBold = false) => (isBold && text?.alternateFontStyle ? AlternateArtemisFonts(text) : ArtemisFonts(text));

export default loadArtemisFonts;
